const DigitalSignatureParticipantStatus = Object.freeze({
  Unset: 0,
  Signed: 1,
  Pending: 2,
});

export const DigitalSignatureParticipantStatusColor = Object.freeze({
  [DigitalSignatureParticipantStatus.Signed]: 'orange-light-1',
  [DigitalSignatureParticipantStatus.Pending]: 'brown-1',
});

export default DigitalSignatureParticipantStatus;
